module.exports = __webpack_public_path__ + "media/assets/icons/reports-3477cdfe75e78187b65fae48971d418b.svg";